







import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';

@Component
export default class DebugUserIcon extends Vue {

  // サイズ
  @Prop({ type: Number, required: true })
  private size!: number;

  // カラー
  private mycolor: string = this.randomGradBGCSS();

  // サイズ
  get avatarSize(): number {
    return this.size;
  }

  // ランダムに背景グラーションCSSを返します
  public randomGradBGCSS(): string {
    return (
      'background: linear-gradient(' +
      this.randomColor() +
      ', ' +
      this.randomColor() +
      ');'
    );
  }

  // ランダムにカラーを返します
  public randomColor(): string {
    const rgb = [];
    for (let i = 0; i < 3; i++) rgb.push(Math.floor(Math.random() * 255));

    return 'rgb(' + rgb.join(',') + ')';
  }
}
